import React from 'react'
import { connect } from 'react-redux'
import { logout } from '../actions'

class LogoutBox extends React.Component {
  render () {
    return (
      <a onClick={this.props.onLogout}>Logout</a>
    )
  }
}

const mapStateToProps = (state) => {
  return {
    isAuthenticated: state.auth.isAuthenticated,
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
    onLogout: () => {
      dispatch(logout({}))
    }
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(LogoutBox)



// WEBPACK FOOTER //
// ./src/modules/auth/logout/container.js